import { get } from "lodash";
import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Table, Loader, Container } from "semantic-ui-react";

import EstimateScheduleSelection from "./EstimateScheduleSelection.jsx";
import EstimateRow from "./EstimateRow.jsx";
import EstimateSummaryView from "./EstimateSummaryView.jsx";

import { AT_TYPES, ALL_RESOURCE_KEYS } from "../../../constants/entity.js";
import { OPERATIONS } from "../../../constants/operations.js";

import { getSchedules } from "../../../state/reducers/schedules/scheduleActions.js";

import scheduleSelector from "../../../state/reducers/schedules/scheduleSelector.js";
import estimatesSelector from "../../../state/reducers/estimates/estimateSelector.js";
import { selectOperationAvailability } from "../../../state/reducers/endpoints/endpointSelector.js";
import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class EstimatePanel extends PureComponent {
  static propTypes = {
    id: PropTypes.string,
    formikProps: PropTypes.object.isRequired,
    isFetching: PropTypes.bool.isRequired,
    listScheduleAvailability: PropTypes.object.isRequired,
    estimateAvailability: PropTypes.object.isRequired,
    configOptions: PropTypes.object,
    docked: PropTypes.bool.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    docked: false,
    copyKey: "project_wizard.estimate_panel"
  };

  constructor(props) {
    super(props);

    const showDetails = get(props, "configOptions.showDetails", false);

    this.state = {
      showDetails
    };
  }

  componentDidMount = () => {
    const {
      listScheduleAvailability: { permitted, enabled }
    } = this.props;

    if (permitted === true && enabled === true) {
      this.props.getSchedules();
    }
  };

  // -- HANDLERS -- //

  handleShowDetails = () => {
    const { showDetails } = this.state;

    this.setState({ showDetails: !showDetails });
  };

  // -- RENDER -- //

  renderEstimate = () => {
    const {
      formikProps: {
        values: { dimension }
      },
      estimates,
      scheduleNames,
      copyKey,
      copy
    } = this.props;

    return (
      <Table unstackable celled compact>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell rowSpan={2}>
              {copy(`${copyKey}.services`)}
            </Table.HeaderCell>
            {estimates.map(estimate => {
              return (
                <Table.HeaderCell key={estimate.id} collapsing>
                  {scheduleNames[estimate.id]}
                </Table.HeaderCell>
              );
            })}
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {ALL_RESOURCE_KEYS.map(type => {
            return (
              <EstimateRow
                key={type}
                resourceType={type}
                copyKey="resource_types.plural"
                estimates={estimates}
                dimension={dimension}
                CellComponent={Table.Cell}
              />
            );
          })}
        </Table.Body>

        <Table.Footer>
          <EstimateRow
            key="total"
            resourceType="total"
            copyKey={copyKey}
            estimates={estimates}
            dimension={dimension}
            CellComponent={Table.HeaderCell}
          />
        </Table.Footer>
      </Table>
    );
  };

  renderNoEstimate = () => {
    const { copyKey, isFetching, copy } = this.props;

    if (isFetching) {
      return (
        <Fragment>
          <br />
          <Loader inverted inline="centered" active />
        </Fragment>
      );
    }
    return <p>{copy(`${copyKey}.no_estimate`)}</p>;
  };

  render() {
    const {
      formikProps: {
        values: { dimension }
      },
      estimateAvailability: { permitted, enabled },
      estimates,
      isFetching,
      configOptions,
      docked
    } = this.props;

    const { showDetails } = this.state;
    const controlsEnabled = get(configOptions, "controlsEnabled", true);

    // needs activating on the api
    if (!permitted || !enabled) return null;

    return (
      <Container className="estimates-panel">
        <EstimateSummaryView
          isFetching={isFetching}
          estimates={estimates}
          dimension={dimension}
          showDetails={showDetails}
          docked={docked}
          controlsEnabled={controlsEnabled}
          handleShowDetails={this.handleShowDetails}
        />
        {showDetails && (
          <Segment inverted attached="bottom">
            <EstimateScheduleSelection />
            {estimates ? this.renderEstimate() : this.renderNoEstimate()}
            <br />
          </Segment>
        )}
      </Container>
    );
  }
}

const mapStateToProps = (state, props) => ({
  estimates: estimatesSelector.selectEstimates(state, props),
  isFetching: state.estimates.isFetching,
  listScheduleAvailability: selectOperationAvailability(state)(
    AT_TYPES.SCHEDULE,
    OPERATIONS.LIST
  ),
  estimateAvailability: selectOperationAvailability(state)(
    AT_TYPES.ESTIMATE,
    OPERATIONS.ESTIMATE
  ),
  scheduleNames: scheduleSelector.selectScheduleNames(state),
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  getSchedules: id => dispatch(getSchedules(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(EstimatePanel);
